/**
 * case分などで実装漏れがないか確認するために利用
 */
export const assertNever = (x: never) => {
  console.log(`${x} shoud be never`);
  // 旧データの場合、assertNeverに引っかかってしまう場合があるためconsoleにする
  // throw new Error(`${x} shoud be never`);
};
